import React, { useState, useEffect, useReducer, useCallback, useMemo, useContext } from 'react';

import CrmGrid from '../../../UI/Crm/CrmGrid/CrmGrid';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from "react-i18next";
import SubModal from '../../../UI/Crm/SubModal/SubModal';
import CrmTextField from '../../../UI/Crm/Fields/CrmTextField'
import CrmSelectField from '../../../UI/Crm/Fields/CrmSelectField';
import CrmCheckBoxField from '../../../UI/Crm/Fields/CrmCheckBoxField';
import { getUserModules } from '../../../../axios/requests/moduleReq'
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext'
import * as actions from '../../../../store/actions/index'
import validator from 'validator';
import CrmButton from '../../../UI/Crm/CrmButton/CrmButton';
import {
    Box,
    Divider,
} from '@mui/material';

const initManageRelationshipState = {
    relationshipObj: null,
    showModal: false,
    mode: null// [INSERT,PATCH]
}

const manageRelationshipReducer = (state, action) => {
    switch (action.type) {
        case 'TOGGEL_MODAL':
            return { ...state, showModal: !state.showModal }
        case 'SET_FIELD':
            return { ...state, relationshipObj: action.relationshipObj, mode: action.mode, showModal: true }
        case 'PATCH_FIELD':
            const { name, value, type, checked } = action.payload;
            const newField = { ...state.relationshipObj, [name]: type === 'checkbox' ? checked : value }
            return { ...state, relationshipObj: newField }
        case 'CLEAR_ALL':
            return initManageRelationshipState
        default:
            return state
    }
}

const RelationshipManagment = () => {// manageFieldState.relationshipObj.
    const [relationships, setRelationships] = useState([])
    const [moduleListState, setModuleListState] = useState([])
    const alertCtx = useContext(AlertContext)
    const crmState = useSelector(state => state.crm)
    // const [errors, setErrors] = useState({});
    const [manageRelationshipState, manageRelationsDispatch] = useReducer(manageRelationshipReducer, initManageRelationshipState)
    const [t] = useTranslation('crm')
    const dispatch = useDispatch()
    const { selectedCrmModule } = crmState

    const newRelationshipObj = useMemo(() => ({
        isPrimary: false,
        relationShipType: 'MANY_TO_MANY',
        primaryModuleName: selectedCrmModule?.name,
        // relatedModuleLabel: selectedCrmModule?.label
        primaryModuleLabel: selectedCrmModule?.label
    }), [selectedCrmModule])

    
    useEffect(() => {
        const initModules = async () => {
            const modules = await getUserModules()
            let selfModuleIndex
            for (let i = 0; i < modules.length; i++) {
                const module = modules[i]
                module.value = module.name
                if (module.name === selectedCrmModule.name) selfModuleIndex = i
            }
            if (!manageRelationshipState.relationshipObj?.isPrimary) {
                modules.splice(selfModuleIndex, 1)
            }
            setModuleListState(modules)
        }


        if (selectedCrmModule?.relatedModules) {
            initModules()
            for (const relatedModule of selectedCrmModule.relatedModules) {
                
                if (relatedModule.isPrimary) {
                    relatedModule.primaryModuleName = relatedModule.moduleId?.name
                    relatedModule.primaryModuleLabel = relatedModule.moduleId?.label
                    relatedModule.relatedModuleName = selectedCrmModule.name
                    relatedModule.relatedModuleLabel = selectedCrmModule.label
                }
                else {
                    
                    relatedModule.primaryModuleName = selectedCrmModule.name
                    relatedModule.primaryModuleLabel = selectedCrmModule.label
                    relatedModule.relatedModuleName = relatedModule.moduleId?.name || relatedModule.name
                    relatedModule.relatedModuleLabel = relatedModule.moduleId?.label ||relatedModule.label
                }
                relatedModule.relationShipTypeLabel = t(relatedModule.relationShipType)
            }

            setRelationships(selectedCrmModule.relatedModules)
        }
    }, [selectedCrmModule, manageRelationshipState.relationshipObj?.isPrimary])

    // const validations = useCallback((name, value) => {
    //     if (typeof value !== 'string') return
    //     if (name === 'name') {
    //         if (validator.isEmpty(value)) {
    //             return `${t('Field name')}: ${t(`Required`)}`;
    //         }
    //     }
    //     return;
    // }, [manageFieldState.relationshipObj?.type])

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        manageRelationsDispatch({ type: 'PATCH_FIELD', payload: { name, value, type, checked } })

        // const error = validations(name, value);
        // setErrors((prev) => ({ ...prev, [`${name}`]: error }));
    };

    const handleNewFieldClick = useCallback(() => {
        manageRelationsDispatch({ type: 'SET_FIELD', relationshipObj: newRelationshipObj, mode: 'INSERT' })
    }, [])

    const handleFieldClick = useCallback((event) => {
        if (event?.data) {
            manageRelationsDispatch({ type: 'SET_FIELD', relationshipObj: event.data, mode: 'PATCH' })
        }
    }, [])

    const relationShipTypes = [
        { label: 'רבים לרבים', value: 'MANY_TO_MANY' },
        { label: 'אחד לרבים', value: 'ONE_TO_MANY' },
        { label: 'אחד לאחד', value: 'ONE_TO_ONE' },
    ]

    const columnDefs = [
        { field: 'relationShipName', headerName: t('name'), flex: 1 },
        { field: 'primaryModuleLabel', headerName: t('primaryModule'), flex: 1 },
        { field: 'relationShipTypeLabel', headerName: t('relationShipType'), flex: 1 },
        { field: 'relatedModuleLabel', headerName: t('relatedModule'), flex: 1 },
    ]

    const modalToggel = useCallback(() => {
        if (manageRelationshipState.showModal === true) {
            manageRelationsDispatch({ type: 'CLEAR_ALL' })
            // setErrors({});
        }
        else {
            manageRelationsDispatch({ type: 'TOGGEL_MODAL' })
        }

    }, [manageRelationshipState.showModal])

    const handleRemoveRelationship = useCallback((_id) => {
        if (!_id) return console.log('Relationship not selected.')
        setRelationships((relationships) => {
            const newRelationShips = JSON.parse(JSON.stringify(relationships))
            const deleteRelationshipIndex = newRelationShips.findIndex((relationship) => relationship._id === _id)
            if (deleteRelationshipIndex > -1) {
                newRelationShips.splice(deleteRelationshipIndex, 1)
                return newRelationShips
            }
            return relationships
        })
        const updatedModule = JSON.parse(JSON.stringify(selectedCrmModule))

        if (updatedModule?.relatedModules) {
            const relatedModuleIndex = updatedModule.relatedModules.findIndex((relatedModule) => relatedModule._id === _id)
            if (relatedModuleIndex > -1) {
                updatedModule.relatedModules.splice(relatedModuleIndex, 1)
            }
        }

        // Wrap in setTimeout to avoid AG Grid rendering conflicts
        setTimeout(() => {
            dispatch(actions.updateCrmModule(updatedModule))
            modalToggel()
        }, 0)
    }, [selectedCrmModule])

    const handleSubmit = () => {
        const updatedModule = JSON.parse(JSON.stringify(selectedCrmModule))

        // const errors = submitValidation()
        // if (errors) {
        //     return alertCtx.showAlert(t('Error'), errors, 'md')
        // }

        let toSaveRelationshipObj = { ...manageRelationshipState.relationshipObj }

        if (moduleListState.length > 0) {
            const selectedRelatedModule = (moduleListState.find((module) => module.name === toSaveRelationshipObj.relatedModuleName))
            if (!selectedRelatedModule) {
                return alertCtx.showAlert(t('Error'), t('No related module selected. Please select a related module and then click Save'), 'md')
            }
            toSaveRelationshipObj.moduleId = selectedRelatedModule._id
            toSaveRelationshipObj.label = selectedRelatedModule.label
            toSaveRelationshipObj.name = selectedRelatedModule.name
            toSaveRelationshipObj.relationShipName = `${updatedModule.name}_${toSaveRelationshipObj.relationShipType}_${selectedRelatedModule.name}`
        }
        else {
            return alertCtx.showAlert(t('Error'), t('Some modules are missing from the list of linked modules. Please contact the system administrator'), 'md')
        }

        if (updatedModule?.relatedModules) {
            if (manageRelationshipState.mode === 'PATCH') {
                const relatedModuleIndex = updatedModule.relatedModules.findIndex((relatedModule) => relatedModule._id === toSaveRelationshipObj._id)
                if (relatedModuleIndex > -1) updatedModule.relatedModules[relatedModuleIndex] = toSaveRelationshipObj
            }
            else if (manageRelationshipState.mode === 'INSERT') {
                updatedModule.relatedModules.push(toSaveRelationshipObj)
            }
        }

        // Wrap in setTimeout to avoid AG Grid rendering conflicts
        setTimeout(() => {
            dispatch(actions.updateCrmModule(updatedModule))
            modalToggel()
        }, 0)
    };

    const onChangeRelatedModulesOrder = useCallback((relatedModules) => {
        const newRelatedModules = JSON.parse(JSON.stringify(relatedModules))
        for (let i = 0; i < relatedModules.length; i++) {
            newRelatedModules[i].order = i + 1
        }
        const updatedModule = JSON.parse(JSON.stringify(selectedCrmModule))
        updatedModule.relatedModules = newRelatedModules

        // Wrap in setTimeout to avoid AG Grid rendering conflicts
        setTimeout(() => {
            dispatch(actions.updateCrmModule(updatedModule))
        }, 0)
    }, [selectedCrmModule]);

    return (
        <section >
            <CrmGrid
                rowData={relationships}
                columnDefs={columnDefs}
                multiSelectionEnable={false}
                supportManageColumns={false}
                supportFiltering={false}
                supportMore={false}
                onRowClicked={handleFieldClick}
                onNewClicked={handleNewFieldClick}
                onOrderChanged={onChangeRelatedModulesOrder}
            />
            {
                manageRelationshipState.showModal &&
                <SubModal
                    modalTitle={manageRelationshipState.relationshipObj ? t('Edit field') : t('Create new field')}
                    onHide={modalToggel}
                >
                    <Box
                        component="form"
                        onSubmit={(e) => e.preventDefault()}
                        noValidate
                        sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}
                    >
                        <CrmTextField label={t('primaryModule')} name="name" value={manageRelationshipState.relationshipObj?.primaryModuleLabel} disabled={true} onChange={handleChange} />
                        <CrmSelectField label={t('relationShipType')} name="relationShipType" disabled={manageRelationshipState.mode === 'PATCH'} value={manageRelationshipState.relationshipObj?.relationShipType} onChange={handleChange} options={relationShipTypes} />
                        <CrmSelectField label={t('relatedModule')} name="relatedModuleName" disabled={manageRelationshipState.mode === 'PATCH'} value={manageRelationshipState.relationshipObj?.relatedModuleName} onChange={handleChange} options={moduleListState} />

                        <Divider />
                        <Box display="flex" justifyContent="flex-end" gap={2}>
                            {/* <CrmButton variant="contained" color="primary" onClick={handleSubmit}>
                                {t('Save')}
                            </CrmButton> */}
                            <CrmButton color="crmContainedGray94" onClick={handleSubmit}>
                                {t('Save')}
                            </CrmButton>
                            {manageRelationshipState.mode === 'PATCH' &&
                                <CrmButton color="error" variant="contained" onClick={() => handleRemoveRelationship(manageRelationshipState.relationshipObj?._id)}>
                                    {t('Delete')}
                                </CrmButton>
                            }
                            {/* <CrmButton variant="outlined" color="primary" onClick={modalToggel}>
                                {t('Cancel')}
                            </CrmButton> */}
                            <CrmButton color="crmOutlinedGray94" onClick={modalToggel}>
                                {t('Cancel')}
                            </CrmButton>
                        </Box>
                    </Box>
                </SubModal>
            }
        </section >
    );
};

export default RelationshipManagment;
